module.exports = __webpack_public_path__ + "/login_ui/img/br-dd2df2eee75bd9dfd1af597f3f23804f.svg";